import {BaseService} from './base.service'
import {IReceptionParameter, IReceptionDetailViewModel} from '../models/reception'
import {Uris} from '../common/constants'
import {IBaseListingModel} from '../models/base-listing.model'
import * as JSONPatch from 'fast-json-patch'

export interface IReceptionService {
  getReceptions(param: IReceptionParameter, allowPagination?: boolean): Promise<IBaseListingModel>;

  getReceptionById(id: string): Promise<IReceptionDetailViewModel>;

  getReceptionSectionsByReceptionId(id: string): Promise<any>;

  getSectionById(receptionId: string, id: number): Promise<any>;

  getReceptionTypes(): Promise<any>
}

export class ReceptionService extends BaseService implements IReceptionService {
  receptionParameter: IReceptionParameter

  async getReceptionTypes (): Promise<any> {
    return super.get(Uris.ReceptionTypes)
  }

  async getReceptionById (id: string): Promise<IReceptionDetailViewModel> {
    return super.get(Uris.ReceptionById.replace(':id', id))
  }

  async getSectionById (receptionId: string, id: number): Promise<any> {
    return super.get(Uris.ReceptionSectionById
      .replace(':id', receptionId)
      .replace(':sid', id.toString()))
  }

  async getReceptionSectionsByReceptionId (id: string): Promise<any> {
    return super.get(Uris.ReceptionSectionsById.replace(':id', id))
  }

  async getReceptions (param: IReceptionParameter, allowPagination?: boolean): Promise<any> {
    let cookedParameter = JSON.parse(JSON.stringify(param))
    if (!this.receptionParameter) {
      this.receptionParameter = cookedParameter
    } else {
      const changes = JSONPatch.compare(this.receptionParameter, cookedParameter)
      const orderChanges = changes.find(x => x.path.indexOf('order') > -1)
      if (orderChanges) {
        const paths: string[] = orderChanges.path.split('/')
        const index: number = Number(paths[paths.length - 1])
        this.receptionParameter = cookedParameter
        cookedParameter = {
          ...cookedParameter,
          orderKeys: [cookedParameter.orderKeys[index]],
          orderValues: [cookedParameter.orderValues[index]]
        }
      }
    }

    return super.get(Uris.Reception, cookedParameter)
      .then((rawTickets: IBaseListingModel) => {
        if (allowPagination) {
          return Promise.resolve(rawTickets)
        }
        return Promise.resolve(rawTickets.data)
      })
      .catch(error => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/services/reception.service.ts